import React from 'react'

import { useAppSelector } from '../../../state/hooks'
import { selectSalePayments } from '../../../state/slices/currentSale/currentSaleSlice'
import { isNotHiddenPayment } from '../../../functions/sale'
import { dateFormat } from '../../../filters/wr-date-format'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'
const dateTimeFormat = 'ddd, D MMM YY h:mma'
export const PaymentSection = () => {
  const payments = useAppSelector(selectSalePayments)
  const formatCurrencyValue = useFormatCurrencyValue()
  const filteredPayments = payments.filter(isNotHiddenPayment)
  if (!filteredPayments.length) {
    return null
  }

  return (
    <section
      className="sale-summary-section sale-summary-section--indent pro-summary-section-payments"
      data-testid="summary-panel-payments"
    >
      <ul className="sale-summary-list">
        {filteredPayments.map(payment => {
          const {
            paymentType: { name: paymentName },
            paymentDate,
            amount,
          } = payment
          return (
            <li
              className="wr-sale-summary-payments sale-summary-line"
              key={payment.localId}
            >
              <div className="sale-summary-line-item sale-summary-line-item--label">
                <span className="pro-sale-summary-payment-name">
                  {paymentName}
                </span>
                <div className="vd-text-supplementary">
                  {dateFormat(paymentDate, dateTimeFormat)}
                </div>
              </div>
              <div className="sale-summary-line-item sale-summary-line-item--value">
                <span>{formatCurrencyValue(amount)}</span>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
